import clsx from 'clsx'
import { useT } from '_metronic/i18n/Metronici18n'
import { SituacaoDispositivo } from '../core/_models'
import { rotuloSituacao } from '../core/rotulos'
import styles from './Selos.module.css'

export type TomSelo = 'neutro' | 'apagado' | 'sucesso' | 'atencao' | 'perigo'

/** Selo com texto: a cor reforça, o rótulo carrega o significado. */
export const Selo = ({ tom = 'neutro', children }: { tom?: TomSelo; children: string }) => (
  <span className={clsx(styles.selo, styles[tom])} title={children}>
    {children}
  </span>
)

/**
 * Tom da situação. Manutenção/calibração em atenção, extraviado em perigo, baixado apagado e o
 * resto neutro. "Em uso" ganha `sucesso` só quando a tela não mostra atenção e perigo ao mesmo
 * tempo (no máximo dois matizes funcionais por tela — BRAND.md).
 */
export const tomSituacao = (
  situacao: SituacaoDispositivo,
  situacoesVisiveis: readonly SituacaoDispositivo[] = []
): TomSelo => {
  switch (situacao) {
    case 'EM_MANUTENCAO':
    case 'EM_CALIBRACAO':
      return 'atencao'
    case 'EXTRAVIADO':
      return 'perigo'
    case 'BAIXADO':
      return 'apagado'
    case 'EM_USO': {
      const temAtencao = situacoesVisiveis.some(
        (s) => s === 'EM_MANUTENCAO' || s === 'EM_CALIBRACAO'
      )
      const temPerigo = situacoesVisiveis.includes('EXTRAVIADO')
      return temAtencao && temPerigo ? 'neutro' : 'sucesso'
    }
    default:
      return 'neutro'
  }
}

export const SituacaoSelo = ({
  situacao,
  situacoesVisiveis,
}: {
  situacao?: SituacaoDispositivo | null
  situacoesVisiveis?: readonly SituacaoDispositivo[]
}) => {
  const { t } = useT()
  if (!situacao) return <span title='—'>—</span>
  return <Selo tom={tomSituacao(situacao, situacoesVisiveis)}>{rotuloSituacao(t, situacao)}</Selo>
}
